<script>
import { PortalTarget } from 'portal-vue';

export default {
  name: 'BreadcrumbsApp',
  components: {
    PortalTarget,
  },
};
</script>

<template><portal-target name="breadcrumbs" /></template>
